import React from 'react';
import styled from 'styled-components';


const StyledLastSample = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 90%;
  margin: 0 auto 20px auto;
`;

const Row = styled.tr`
  colour: #292D34;
  font-size: 18px;
  padding 20px 0;
  border: 1px solid #dddddd;
`;

const HeadingCell = styled.th`
  vertical-align: middle;
  height: 40px;
  font-size: 16px;
  text-align: left;
  padding: 8px 10px;
`;

const Cell = styled.td`
  vertical-align: middle;
  padding: 8px 10px;
  font-size: 14px;
  text-align: left;
`;

export const LastSample = ({ type, subtype, limits }: { type?: any; subtype?: any; limits?: any; }) => {
  
  return (
    <StyledLastSample>
      <Table>
        <Row>
          <HeadingCell>Start</HeadingCell>
          <HeadingCell>Finish</HeadingCell>
          <HeadingCell>Duration</HeadingCell>
          <HeadingCell>LAeq</HeadingCell>
          <HeadingCell>LAmax</HeadingCell>
          <HeadingCell>LA90</HeadingCell>
          <HeadingCell>LA70</HeadingCell>
          <HeadingCell>LA50</HeadingCell>
          <HeadingCell>LA30</HeadingCell>
          <HeadingCell>LA10</HeadingCell>
        </Row>
        <Row>
          <Cell>2020/06/04 12:30:00 BST</Cell>
          <Cell>2020/06/04 12:32:00 BST</Cell>
          <Cell>1m</Cell>
          <Cell>33.9</Cell>
          <Cell>42.8</Cell>
          <Cell>25.9</Cell>
          <Cell>26.1</Cell>
          <Cell>26.5</Cell>
          <Cell>30.1</Cell>
          <Cell>39.0</Cell>
        </Row>
      </Table>
    </StyledLastSample>
  )
}

